import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import {
  Box,
  Input,
  Table,
  TableCaption,
  Button,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  AlertDialog,
  useDisclosure,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import toast from "react-hot-toast";
import Cookie from "js-cookie";
import KotbillPrintModal from "./kotPrintModal";
import WhitebillPrintModal from "./whiteBillPrintModel";
import WhitebillChangeModal from "./whiteBillChanges";

const WhiteBillData = () => {
  const [data, setData] = useState([]);
  const token = Cookie.get("token");
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [changedData, setChangedData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 100; // or any number you prefer

  const [deleteItemId, setDeleteItemId] = useState(null);
  const cancelRef = useRef();
  const {
    isOpen: isPrintOpen,
    onOpen: onPrintOpen,
    onClose: onPrintClose,
  } = useDisclosure();
  const {
    isOpen: isModalOpen,
    onOpen: onModalOpen,
    onClose: onModalClose,
  } = useDisclosure();
  const handlePrintModal = () => {
    onPrintOpen();
  };
  const handleChangedOpen = (data) => {
    setChangedData(data);
    onModalOpen();
  };
  const customerId = localStorage.getItem("customerId");

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getWhiteBill/${customerId}?customerId=${customerId}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setData(response.data.whiteBillData);
      setFilteredData(response.data.whiteBillData);
    } catch (error) {}
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  useEffect(() => {
    fetchData();
  }, [customerId, startDate, endDate]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter((order) => {
      const orderDate = new Date(order.createdAt).getTime();

      console.log(typeof order.tableNo, "tableNo");
      if (term && !order.tableNo.includes(term)) {
        return false;
      }

      return true;
    });

    setFilteredData(filtered);
  };
  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `https://api.rasoi.launchlysoftware.in/api/kotDelete/${customerId}/${deleteItemId}?customerId=${customerId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success(response.data.message);
      setIsOpen(false);
      fetchData();
    } catch (error) {
      if (error.response.status === 403) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };
  const openModal = (id) => {
    setDeleteItemId(id);
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
    setDeleteItemId(null);
  };

  return (
    <Box p={6} bg="gray.50" minH="90vh">
      <Box
        display="flex"
        flexWrap="wrap"
        gap={4}
        mb={6}
        p={4}
        bg="white"
        borderRadius="lg"
        boxShadow="md"
      >
        <Input
          w="180px"
          type="date"
          placeholder="Start Date"
          value={startDate}
          onChange={handleStartDateChange}
          bg="white"
        />
        <Input
          w="180px"
          type="date"
          placeholder="End Date"
          value={endDate}
          onChange={handleEndDateChange}
          bg="white"
        />
        <Button colorScheme="teal" onClick={handlePrintModal}>
          Print
        </Button>
      </Box>
      <Box
        width="full"
        bg="white"
        borderRadius="lg"
        boxShadow="md"
        maxH="calc(100vh - 250px)"
        overflowY="auto"
        overflowX="auto"
      >
        <Table size="sm" variant="simple">
          <TableCaption placement="top" fontSize="lg" fontWeight="bold" mb={2}>
            Void Bill Data
          </TableCaption>
          <Thead position="sticky" top={0} bg="green.500" zIndex={10}>
            <Tr>
              <Th color="white">Message</Th>
              <Th color="white">Bill No</Th>
              <Th color="white">KOT No</Th>
              <Th color="white">Edited By</Th>
              <Th color="white">Deleted By</Th>
              <Th color="white">View Changes</Th>
              <Th color="white">Created At</Th>
            </Tr>
          </Thead>
          <Tbody>
            {currentItems.map((order, index) => (
              <Tr key={index}>
                <Td py={3}>{order.message}</Td>
                <Td py={3}>{order.billNo}</Td>
                <Td py={3}>{order.kotNo}</Td>
                <Td py={3}>{order.editedBy}</Td>
                <Td py={3}>{order.deletedBy}</Td>
                <Td py={3}>
                  <Button
                    colorScheme="blue"
                    size="sm"
                    onClick={() => handleChangedOpen(order.changed)}
                  >
                    View
                  </Button>
                </Td>
                <Td py={3}>
                  {new Date(order.createdAt).toLocaleString("en-GB")}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirm Deletion
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure you want to delete this item?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleDelete} ml={3}>
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <WhitebillPrintModal
        isOpen={isPrintOpen}
        onOpen={onPrintOpen}
        onClose={onPrintClose}
        data={filteredData}
      />
      <WhitebillChangeModal
        data={changedData}
        onOpen={onModalOpen}
        onClose={onModalClose}
        isOpen={isModalOpen}
      />
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={6}
        gap={2}
      >
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
          size="sm"
          colorScheme="blue"
          variant="outline"
        >
          Previous
        </Button>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            size="sm"
            colorScheme="blue"
            onClick={() => handlePageChange(i + 1)}
            variant={currentPage === i + 1 ? "solid" : "outline"}
          >
            {i + 1}
          </Button>
        ))}
        <Button
          colorScheme="blue"
          size="sm"
          variant="outline"
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

export default WhiteBillData;
